import Header from "src/components/layout/Header";
import { useTranslation } from "react-i18next";
import { CashReceiptForm } from "../paymentDetails/CashReceiptForm";
import { useCallback, useEffect, useMemo, useState } from "react";
import { getExpenseProofAsync, postExpenseProofAsync } from "src/api/contract/contract-api";
import { useApiOperation } from "src/api/hooks";
import moment from "moment";
import { YmdFormat } from "src/utils/common-util";
import { useNavigate, useParams } from "react-router-dom";
import { Modal } from "src/pages/contract/contract-types";
import _ from "lodash";
import { ConfirmModal } from "src/components";

// 현금영수증 정보 컴포넌트
// 현금영수증 발급 정보를 수정하는 컴포넌트
const CashBillInfo = () => {
  const { t } = useTranslation("contract");
  // URL 파라미터에서 계약 ID 가져오기
  const { contractId } = useParams();
  const navigate = useNavigate();

  // 알림 모달 상태 관리
  const [alertModal, setAlertModal] = useState<Modal>({
    isOpen: false,
    message: "",
    subMessage: "",
  });

  // API 호출 훅
  const { executeAsync: getExpenseProof } = useApiOperation(getExpenseProofAsync);
  const { executeAsync: saveExpenseProof } = useApiOperation(postExpenseProofAsync, { noHandleError: true, anotherHandleError: true });

  // 증빙서류 요청 정보 상태 관리
  const [documentProofRequest, setDocumentProofRequest] = useState<any>({
    identityNum: "",
    mediaList: [],
    taxInvoiceEmail: "",
    taxInvoicePhone: "",
    taxInvoiceDate: null,
  });

  // 에러 정보 초기화
  const errorInit: any = useMemo(() => {
    return {
      error: {
        identityNum: false,
        identityType: false,
        mediaList: false,
        taxInvoiceEmail: false,
        taxInvoicePhone: false,
        taxInvoiceDate: false,
      },
      format: {
        identityNum: false,
        identityType: false,
        mediaList: false,
        taxInvoiceEmail: false,
        taxInvoicePhone: false,
        taxInvoiceDate: false,
      },
    };
  }, []);

  // 에러 상태 관리
  const [proofError, setProofError] = useState<any>(_.cloneDeep(errorInit));

  // 계약 증빙 자료 조회 함수
  const fetchContractProof = useCallback(
    async (contractId: string) => {
      const { data: data2 } = await getExpenseProof({ contractId });

      if (data2.data.expenseProofRequest.mediaList !== null) {
        data2.data.expenseProofRequest.mediaList.forEach((dt: any) => {
          dt["cmdType"] = "U";
        });
        setDocumentProofRequest(data2.data.expenseProofRequest);
      }
    },
    [getExpenseProof],
  );

  // 모달 닫기 핸들러
  const onClose = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  // 현금영수증 발급 정보 저장 핸들러
  const handleClickExpenseProofCashBill = useCallback(
    async (handleClickExpenseProof: any) => {
      if (handleClickExpenseProof.taxInvoiceDate !== null && handleClickExpenseProof.taxInvoiceDate !== "") {
        handleClickExpenseProof.taxInvoiceDate = moment(handleClickExpenseProof.taxInvoiceDate).format(YmdFormat.YYYY_MM_DD) + "T00:00:00.000+09:00";
      }

      if (handleClickExpenseProof.contractId !== null && Number(handleClickExpenseProof.contractId) > 0) {
        handleClickExpenseProof.cmdType = "U";
      } else {
        handleClickExpenseProof.cmdType = "C";
      }

      const saveExpense: any = await saveExpenseProof({ contractId: String(contractId), expenseProofRequest: handleClickExpenseProof });
      if (saveExpense && saveExpense.status > 199 && saveExpense.status < 400) {
        setAlertModal({
          ...alertModal,
          isOpen: true,
          message: t("detail.cashReceiptInfoUpdated"),
        });
      } else {
        setAlertModal({
          ...alertModal,
          isOpen: true,
          message: t("detail.alreadyIssuedCannotModify"),
        });
      }
    },
    [saveExpenseProof, contractId, alertModal, t],
  );

  // 컴포넌트 마운트 시 계약 증빙 자료 조회
  useEffect(() => {
    if (contractId) {
      fetchContractProof(contractId);
    }
  }, [fetchContractProof, contractId]);

  return (
    <>
      {/* 헤더 컴포넌트 */}
      <Header headerType="CLOSE" title={t("detail.cashReceiptIssuanceInfo")} onClickCloseButton={onClose} />

      {/* 현금영수증 정보 입력 섹션 */}
      <div className="base-layout cash-bill-info-page">
        <div className="base-layout">
          <div className="index-title">
            <p className="font15 font-weight-bold mb10 required">{t("detail.cashReceiptIssuanceType")}</p>
          </div>

          {/* 현금영수증 폼 컴포넌트 */}
          <CashReceiptForm proofError={proofError} handleClickExpenseProofCashBill={handleClickExpenseProofCashBill} />
        </div>

        {/* 알림 모달 */}
        {alertModal.isOpen && (
          <ConfirmModal
            isOpen={alertModal.isOpen}
            btnRightTitle={t("detail.confirmOk")}
            onClick={() => {
              setAlertModal({ ...alertModal, isOpen: false });
              onClose();
            }}
          >
            <div>
              <p className="font18 font-weight-600">{alertModal?.message}</p>
              <p className="font18">{alertModal?.subMessage}</p>
            </div>
          </ConfirmModal>
        )}
      </div>
    </>
  );
};

export default CashBillInfo;
